module.exports = __webpack_public_path__ + "img/splash.927b6925.jpg";